export function pluralize<S, P>(
  count: number | null | undefined,
  singular: S,
  plural: P,
) {
  return count === 1 ? singular : plural;
}
